import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, finalize, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from '../../cards/candidate-card/candidate-card.component';
import { CandidateCardTableViewComponent } from '../candidate-card-table-view/candidate-card-table-view.component';
import { CandidateDocumentsComponent } from '../candidate-documents/candidate-documents.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-candiates-invited',
  standalone: true,
  imports: [CommonModule,
CommonSkeletonComponent, CandidateCardComponent, CandidateCardTableViewComponent, CandidateDocumentsComponent, InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candiates-invited.component.html',
  styleUrls: ['./candiates-invited.component.scss'],
  inputs : ['jobDetails']
})
export class CandiatesInvitedComponent implements OnInit, OnDestroy , OnChanges{
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  @Input() designVersion: string = 'v2';
  readonly GigsumoConstants = GigsumoConstants;
  userId: any;
  jobDetails : JobModel;
  @Input() clickedCandidateIdIntraction:string;
  candidateId:string;
  previousValue_jobDetails : JobModel;
  candidateInvitedStatusList: any;
  url = AppSettings.photoUrl;
  jobId: any;
  candidateSeletedFilter;
  entitySent: any = { entity: 'candidates invited' };
  invitedCandidatesFoundStatus = "Fetching invited candidates..."
  queryParamData: any;
  response: any = [];
  previousSearchAfterKey = null;
  stopscrollFlag: boolean = false
  userType: any;
  colorLists: any;
  obj: any = {
    limit: 10,
    jobId: null,
    searchAfterKey: null,
    // entityType: "JOB"
    // userId: localStorage.getItem('userId')
  }
  searchAfterKey=null;
  // The inviteStatus the current searchAfterKey belongs to. A cursor is only
  // meaningful within the result set it came from, so this is what tells us the
  // filter has changed underneath it.
  activeInviteStatus: string = null;
  pageNumber:number=0;
  filterSubscriber: Subscription;
  isFilterOpen: boolean = false;
  panel: string;
  appliedJob: any;
  tempStatusList: any;
  // Status="CANDIDATE_INVITATION"
  // Status="CANDIDATE_INVITATION,JOB_APPLICATION"
  constructor(private util: UtilService, private apiService: ApiService, private searchdata: SearchData,
    private candidateService: CandidateService, private router: Router, private activatedRoute: ActivatedRoute,
    private jobService: JobService, private gigsumoService: GigsumoService) {
    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;
      if (value.panel == 'candidates invited') {

        if(!value.value) {
          if(value.filterData != null) {
            this.onFilterToggle(value.filterData);
          }
        }
        if(value.value == true && !this.isFilterOpen) {
          this.openFilterSlider();
        } else {
          this.isFilterOpen = false;
          this.closeFilterSlider();
        }
      }
    })
    this.colorLists = this.gigsumoService.colorClass
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes.jobDetails.currentValue){
      this.jobDetails = changes.jobDetails.currentValue;
      if( changes.clickedCandidateIdIntraction&&changes.clickedCandidateIdIntraction.currentValue!=undefined){
        this.candidateId = changes.clickedCandidateIdIntraction.currentValue;
      }else{
        this.candidateId =undefined;
      }
      this.previousValue_jobDetails = changes.jobDetails.previousValue;
     this.searchAfterKey=null;
     this.appliedJob = this.jobDetails;
        // Invalidate any in-flight page fetch — a tab re-click during
        // pagination must not append the stale page into the reset list.
        this.fetchGeneration++;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.getApplicantFilter();
        this.findJob();


    }
  }

  ngOnInit() {


    this.scrollGate.attach();

    // this.util.startLoader()
    this.activatedRoute.queryParams.subscribe((res) => {
      this.jobId = res.jobId
      this.queryParamData = res;
      localStorage.setItem('candidatesInvitedStatus', JSON.stringify(["INITIATED"]));
     });
    this.userType = localStorage.getItem('userType')
    this.userId = localStorage.getItem('userId');
    this.response = [];
    this.pageNumber = 0;

    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      const status = this.candidateInvitedStatusList?.map(oject => oject.itemId);
      this.previousValue_jobDetails=this.jobDetails;
      this.getCandidateList(status.toString());
    });
  }




  filterApplicantData : Array<any>= [];
  getApplicantFilter() {
    let entireInviteStatusList: any = []
    const default_invite_stages = GigsumoConstants.JOB_INVITES_DEFAULT_STAGES
    // this.util.startLoader();
    this.loadAPIcall=true;
    this.apiService.create('listvalue/findbyList' , {domain : "JOB_INVITATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS"}).subscribe(res=>{
      // this.util.stopLoader();
      this.loadAPIcall = false; this.scrollGate.pageLanded();

      const sorted : Array<any> =  res.data.JOB_INVITATION_SUPPLIER_ACTIONS && res.data.JOB_INVITATION_SUPPLIER_ACTIONS.listItems;
      this.filterApplicantData = res.data;
      if(sorted){
        this.candidateInvitedStatusList = sorted
        .filter(x=>default_invite_stages.includes(x.itemId))
        .map(x => {
          return {itemId : x.itemId , value : x.value};
        });

        entireInviteStatusList = sorted
        .map(x=> {
          return {itemId: x.itemId, value: x.value}
        })
        this.tempStatusList = entireInviteStatusList;
        this.removedData = this.updatedArr();
        const data = sorted.map(x => {
        let d = Object.keys(this.removedData).find(c => c === x.itemId);
        return d ? x : undefined; }).filter(x => x!= undefined);
        this.filterByStatus(data.map(x => x.itemId).toString());
        console.log("jobins charge " , data , sorted);
      }
     });
  }


  findJob() {
    this.jobService.findByJobId(this.jobDetails.jobId).subscribe(response=>{
      if(response.jobData){
        this.appliedJob = response.jobData;
      }
    });
  }

  ngOnDestroy(): void {


    this.scrollGate.detach();
    if (this.filterSubscriber) {
      this.filterSubscriber.unsubscribe();
    }
  }

  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.jobService.setDataForFilter({...this.removedData});
      this.jobService.setSliderToggle(true, 'candidates invited', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'candidates invited', null,false);
    }
  }

  // Intentional no-op — the child `app-candidate-card-table-view` owns
  // the resume-download flow end-to-end (plan-check via
  // ACTIVE_INTERACTIONS, then registered blob download via
  // `candidates/resumeDownload/...` — see
  // candidate-card-table-view.component.ts:416-466). The child still
  // emits `(onDownloadResume)` for observability; we only listen so
  // Angular doesn't warn about an unbound output, but we MUST NOT
  // trigger a separate `window.open(AppSettings.photoUrl + fileId)`
  // here — that path bypasses plan-gating entirely and would let
  // expired/free users download unlimited resumes. Leave body empty.
  downloadResume(candidate: any): void {
    // No-op on purpose. See comment above.
  }

  open(values: any) {
    var profiledata: any = {};
    profiledata.userId = localStorage.getItem('userId')
    profiledata.userType = localStorage.getItem('userType')
    this.apiService.create('user/profileDetails', profiledata).subscribe(res => {
      let element: any = {}
      element = res.data.creditConsumptions.find(item => item.creditType === AppSettings.JOB_VIEW)

      // this.util.startLoader();
      this.candidateService.updateCandidateViewed(values).subscribe((res) => {

        // this.util.stopLoader();
      }, err => {
        // this.util.stopLoader();
      });


    })
  }



  count: number = 0
  passCandidateId(item) {
    this.getUpdate(item.candidateId,item.flag);

  }


  getUpdate(candId,flag) {
    this.response.forEach(element => {
      if (element.candidateId == candId && flag=='true') {
        element.isSelected = true;
      } else{
        element.isSelected = false;
      }

    });
  }



  @Output() parentValueChange = new EventEmitter<any>();
  pushtoparentcomponent(item) {

    item.parentType="CANDIDATE_INVITATION,JOB_APPLICATION";
    this.parentValueChange.emit(item)
   }





  getCheck(value, index) {
    if (index > 1) {
      return;
    }
    this.response.forEach((element) => {
      if (element.candidateId == value) {
        element.isSelected = true;
        this.searchdata.setJobID(value);
      }
    });

  }


  like(values: any) {
    if (values.isProcessingLike) return;
    let datas: any = {};
    datas.candidateId = values.candidateId
    datas.userId = localStorage.getItem('userId');
    values.isProcessingLike = true;
    // this.util.startLoader();
    this.apiService.updatePut("candidates/updateCandidateLiked", datas).subscribe((res) => {
      if (res.code == '00000') {
        // this.util.stopLoader();
        this.response.forEach(ele => {
          if (res.data.candidateData.candidateId == ele.candidateId) {
            ele.likesCount = res.data.candidateData.likesCount;
            ele.isLiked = true
          }
        })
      }
      values.isProcessingLike = false;
    }, err => {
      values.isProcessingLike = false;
      // this.util.stopLoader();
    });
  }

  filterByStatus(status: any) {
    // Every caller here is filter-driven (first load, removing a status chip,
    // closing the filter slider), so the result set starts over: drop the
    // pagination cursor. getCandidateList only cleared it when the status
    // string CHANGED, so closing the slider without touching anything re-ran
    // the query with the cursor of the last page scrolled to, against a list
    // that had just been emptied. Pagination calls getCandidateList directly
    // and keeps its cursor.
    this.searchAfterKey = null;
    this.stopscrollFlag = false;
    if(status!=""){
      this.getCandidateList(status);
    }else{
      this.invitedCandidatesFoundStatus = 'Please select appropriate filters to show relevant candidate invites.';
      this.returnmsgtoActivity();
    }
  }

  responseReceived: boolean = false;
  loadAPIcall: boolean = false;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  async getCandidateList(status: string) {
    // Changing the filter starts a NEW result set, so the cursor has to go with the
    // old one. It used to be carried over: picking CANDIDATE-SELECTED returned two
    // rows and a key, then switching to a wider status list sent that same key, so
    // Elasticsearch resumed partway through a list that no longer existed and the
    // page came back empty. Only a job change reset it before, never a filter
    // change. Bumping the generation as well so a request still in flight for the
    // previous filter cannot append its rows into the cleared list.
    if (status !== this.activeInviteStatus) {
      this.activeInviteStatus = status;
      this.searchAfterKey = null;
      this.response = [];
      this.stopscrollFlag = false;
      this.fetchGeneration++;
    }
    const gen = this.fetchGeneration;
    try {
      // this.util.startLoader();
      this.loadAPIcall=true;
      this.responseReceived = false;
      this.obj = {
        jobId: this.jobDetails.jobId,
        limit: 10,
        searchAfterKey: this.searchAfterKey,
        inviteStatus: status,
        userId: localStorage.getItem("userId")
      };

      if (this.previousValue_jobDetails != undefined && this.jobDetails.jobId != this.previousValue_jobDetails.jobId) {
        this.searchAfterKey = null;
        this.response = [];
      }

      if(this.obj.searchAfterKey  === null){
        this.response = [];
      }

      const res = await this.apiService.create("candidates/findCandidatesInvitedForTheJob", this.obj).toPromise();
      if (gen !== this.fetchGeneration) return;
      this.responseReceived = true;

      this.handleResponse(res);
    } catch (err) {
      if (gen !== this.fetchGeneration) return;
      this.handleError(err);
    } finally {
      // this.util.stopLoader();
      if (gen === this.fetchGeneration) {
        this.loadAPIcall = false; this.scrollGate.pageLanded();
      }
    }
  }


  // message retunto activity
  returnmsgtoActivity(){
    let item :any={};
    item.parentType="CANDIDATE_INVITATION,JOB_APPLICATION";
    item.data = [];
    item.tab="candidates-invited";
    item.responseMessage="No Data Found";
    this.parentValueChange.emit(item)
  }

handleResponse(res) {
  this.loadAPIcall = false; this.scrollGate.pageLanded();

    if (res.code == "00000") {
      if(res.data && res.data.invitedCandidateList.length<9){
        this.stopscrollFlag=true
      }else{
        this.stopscrollFlag=false
        this.searchAfterKey=res.data.searchAfterKey;
      }
     this.processCandidates(res.data.invitedCandidateList);
     if(res.data.invitedCandidateList==0){
      this.returnmsgtoActivity();
     }
    } else {
        this.handleError(res);
    }
}

processCandidates(candidatess) {
    candidatess.forEach((candidate, index) => this.updateCandidate(candidate, index === 0));
    this.setFlags(this.response.length);
}

getUniqueCandidates(candidates ) {
    return candidates.filter((c, i, arr) => arr.findIndex(t => t.candidateId === c.candidateId) === i);
}

updateCandidate(candidate, isFirst: boolean ) {

    candidate.enrolledOn = candidate.updatedOn;
    candidate.photo = candidate.photo ? AppSettings.photoUrl + candidate.photo : "assets/images/userAvatar.png";


    if (isFirst ) {
        this.searchdata.setJobID({ eachCandidate: true, candId: candidate.candidateId });
        candidate.isSelected = isFirst;
        this.pushtoparentcomponent(candidate)
     }else{
      candidate.isSelected = false;
      if(this.candidateId != undefined && this.candidateId == candidate.candidateId){
        this.response = this.response.map(item => ({
          ...item,
          isSelected: false
        }));
        console.log("coming inside " , candidate);

        candidate.isSelected = true;
        this.pushtoparentcomponent(candidate)
      }
    }

    this.response.push(candidate);
    let data:any=this.response;
    this.response = this.getUniqueCandidates(data);
}

setFlags(length: number) {

    this.invitedCandidatesFoundStatus = length ? "" : "No candidates got invited.";
    this.searchdata.setNUllCheck(length ? "notNull" : "null");
}

handleError(err: any) {
    this.stopscrollFlag = true;
    const failureMessage = err.code === GigsumoConstants.FAILURECODE ?
        "Something went wrong please try again later ...." : "No candidates got invited.";
    this.invitedCandidatesFoundStatus = failureMessage;
}

  messageShown: boolean = false

  requestResume(value) {
    var data: any = {}
    data.candidateId = value.candidateId
    data.resumeRequestLogs = [{ "jobId": this.jobId, "requestedBy": localStorage.getItem('userId') }]
    // this.util.startLoader()
    this.apiService.updatePut('candidates/updateResumeRequests', data).subscribe(res => {
      if (res.code == '00000') {
        // this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Resume request sent",
          showConfirmButton: false,
          timer: 2000,
        })
      }
    }, err => {
      // this.util.stopLoader();
    });
  }

  widgetstick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 5) {
      this.widgetstick = true;
    } else {
      this.widgetstick = false;
    }
  }

  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  updatestatus(name, value, index) {
    // this.util.startLoader();
    this.loadAPIcall=true;

    var data: any = {}
    data.candidateId = value.candidateId;
    data.jobId = this.jobId;
    data.currentStatus = name;
    this.apiService.create('candidates/updateCandidateStatusForJob', data).subscribe(res => {
      // this.util.stopLoader()
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      if (res.code == '00000') {
        //  this.response[index].currentStatus=res.data.jobData.currentStatus;

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Status successfully Updated.",
          showConfirmButton: false,
          timer: 2000,
        })
      }
    }, err => {
      // this.util.stopLoader();
    });
  }

  removedData : any = [];

  updatedArr() {
    const group = {};
    let arr = [...this.candidateInvitedStatusList.map(c=>c.itemId)];
    arr.forEach((element)=>{
      group[element] = true;
    });
    return group;
  }


  removeEntity(value, index) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.pageNumber = 0
    this.candidateInvitedStatusList.splice(index, 1);
    this.removedData[value] = false;
    const status = this.candidateInvitedStatusList.map(x=>x.itemId);
    this.filterByStatus(status.toString());
  }

  onFilterToggle(value: any) {
    console.log("alerttt" , value);

    this.isFilterOpen = false;
    const receivedData = JSON.parse(value);
    const status = receivedData.candidatesInvitedStatus;
    this.candidateInvitedStatusList = status;
    if(status){
      const d =  this.tempStatusList.filter((e) => status.some(v => v === e.itemId));
      this.candidateInvitedStatusList = d;
      this.removedData = {};
      this.candidateInvitedStatusList.forEach(element => {
          this.removedData[element.itemId] =  true;
      });
    }
    this.stopscrollFlag = false
    this.response = []
    this.obj.pageNumber = 0
    this.filterByStatus(this.candidateInvitedStatusList.map(c=>c.itemId).toString());
  }

  // ── Status update from V3 row dropdown ────────────────────────────
  // Owner-only (gated upstream by `jobDetails?.jobPostedBy == userId`).
  // Calls the same canonical applicant-status API job-applicants uses,
  // so an invited candidate that has progressed into the applicant flow
  // can be moved through the pipeline without leaving this tab.
  updateStatus(statusData: any, candidate: any) {
    const status = statusData?.itemId || statusData;
    if (!status || !candidate?.candidateId) return;
    this.util.startLoader();
    const data: any = {
      candidateId: candidate.candidateId,
      jobId: this.jobDetails?.jobId,
      currentStatus: status,
      candidateName: [candidate?.firstName, candidate?.lastName].filter(Boolean).join(' ').trim(),
      jobTitle: this.jobDetails?.jobTitle || candidate?.jobTitle || '',
      createdByUserName: this.jobDetails?.postedByUserName || '',
      createdBy: candidate?.createdBy || '',
      email: candidate?.user?.email || candidate?.email || '',
    };
    this.apiService.create('candidates/updatejobAppliedStatus', data).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res.code == '00000') {
          Swal.fire({ position: 'center', icon: 'success', title: 'Status successfully Updated.', showConfirmButton: false, timer: 2000 });
          candidate.currentStatus = status;
        } else if (res.code == '99998') {
          Swal.fire('Please complete the document verification process', '', 'info');
        } else {
          Swal.fire({ icon: 'error', title: 'Status update failed', text: res?.message || 'The candidate status could not be updated.', showConfirmButton: true });
        }
      },
      () => {
        this.util.stopLoader();
        Swal.fire({ icon: 'error', title: 'Status update failed', text: 'Network error.', showConfirmButton: true });
      }
    );
  }

  // ── Documents slider (V3 documents icon on OFFER-ACCEPTED+ rows) ──
  // Mirrors the flow in job-applicants:1862-2040 verbatim. Same
  // `<app-candidate-documents>` slider, same fetch / save endpoints,
  // same 9-row `typeOfDocuments` template. Lets the recruiter view
  // and reconfigure required docs for an invited candidate that has
  // progressed into the offer/onboarding stages.
  showDocumentSection: boolean = false;
  selectedCandidateForDocument: any;
  totalMandatoryDocuments: any;
  allVerified: any;

  typeOfDocuments = [
    { name: 'Resume', mandatory: false, isUploaded: true, documents: [], headers: [] },
    { name: 'Drivers License', mandatory: false, isUploaded: true, documents: [] },
    { name: 'Employment Authorization Document', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Passport', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Visa', mandatory: false, isUploaded: false, documents: [] },
    { name: 'I-94', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Background Check Certification', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Background Verification', mandatory: false, isUploaded: false, documents: [] },
    { name: 'Drug Screening', mandatory: false, isUploaded: false, documents: [] }
  ];

  documentsRequired = {
    jobId: '', candidateId: '',
    resumeMandatory: '', driversLicenseMandatory: '', employmentAuthorizationMandatory: '',
    passportMandatory: '', visaMandatory: '', i94Mandatory: '',
    backgroundCheckstatusMandatory: '', backgroundCheckCertificateMandatory: '',
    drugScreenMandatory: '', conversationKey: 'SENDER'
  };

  openDocuments(cand: any) {
    if (!cand?.candidateId) return;
    // Clear the previous candidate's documents BEFORE the slider renders.
    // `typeOfDocuments` is a single shared array reused for every candidate,
    // and getSavedRequiredDocuments() repopulates it in place asynchronously
    // (and bails when the candidate has no saved config). Without this reset
    // the slider would show the last candidate's documents during the fetch,
    // and keep showing them entirely when the new candidate has none.
    this.resetTypeOfDocuments();
    this.showDocumentSection = true;
    this.selectedCandidateForDocument = cand;
    this.getSavedRequiredDocuments(cand.candidateId);
  }

  /** Blank out the shared document buckets + header counts so the slider
   *  starts clean for whichever candidate is opened next. */
  resetTypeOfDocuments() {
    for (const doc of this.typeOfDocuments) {
      doc.mandatory = false;
      doc.documents = [];
    }
    this.totalMandatoryDocuments = 0;
    this.allVerified = false;
  }

  closeDocuments() {
    this.showDocumentSection = false;
    this.selectedCandidateForDocument = null;
  }

  refreshDocumentData() {
    if (this.selectedCandidateForDocument) {
      this.getSavedRequiredDocuments(this.selectedCandidateForDocument.candidateId);
    }
  }

  saveDocuments(value: any) {
    this.documentsRequired.jobId = this.jobDetails.jobId;
    this.documentsRequired.candidateId = this.selectedCandidateForDocument.candidateId;
    this.documentsRequired.resumeMandatory = value.find(e => e.name === 'Resume')?.mandatory ?? false;
    this.documentsRequired.driversLicenseMandatory = value.find(e => e.name === 'Drivers License')?.mandatory ?? false;
    this.documentsRequired.employmentAuthorizationMandatory = value.find(e => e.name === 'Employment Authorization Document')?.mandatory ?? false;
    this.documentsRequired.passportMandatory = value.find(e => e.name === 'Passport')?.mandatory ?? false;
    this.documentsRequired.visaMandatory = value.find(e => e.name === 'Visa')?.mandatory ?? false;
    this.documentsRequired.i94Mandatory = value.find(e => e.name === 'I-94')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckstatusMandatory = value.find(e => e.name === 'Background Verification')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckCertificateMandatory = value.find(e => e.name === 'Background Check Certification')?.mandatory ?? false;
    this.documentsRequired.drugScreenMandatory = value.find(e => e.name === 'Drug Screening')?.mandatory ?? false;

    this.util.startLoader();
    this.apiService.create('jobs/requestMandatoryDocuments', this.documentsRequired)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          if (res.code === '00000') {
            this.showDocumentSection = false;
            Swal.fire({ title: 'Required documents updated successfully', icon: 'success', showConfirmButton: false, timer: 2000 });
            this.getSavedRequiredDocuments(value.candidateId);
          } else {
            Swal.fire('', res?.message || 'Something went wrong', 'error');
          }
        },
        error: () => Swal.fire('Something went wrong', '', 'error')
      });
  }

  getSavedRequiredDocuments(candId: any) {
    const payload = { jobId: this.jobDetails.jobId, candidateId: candId };
    this.util.startLoader();
    this.apiService.create('jobs/getContractDocumentDetails', payload)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          const config = res.data?.existingConfig;
          if (!config) return;
          for (const doc of this.typeOfDocuments) {
            switch (doc.name) {
              case 'Resume':                              doc.mandatory = config.resumeMandatory;                       doc.documents = config?.resumeDocuments || []; break;
              case 'Drivers License':                     doc.mandatory = config.driversLicenseMandatory;               doc.documents = config?.driversLicenseDocuments || []; break;
              case 'Employment Authorization Document':   doc.mandatory = config.employmentAuthorizationMandatory;      doc.documents = config?.employmentAuthorizationDocuments || []; break;
              case 'Passport':                            doc.mandatory = config.passportMandatory;                     doc.documents = config?.passportDocuments || []; break;
              case 'Visa':                                doc.mandatory = config.visaMandatory;                         doc.documents = config?.visaDocuments || []; break;
              case 'I-94':                                doc.mandatory = config.i94Mandatory;                          doc.documents = config?.i94Documents || []; break;
              case 'Background Verification':             doc.mandatory = config.backgroundCheckstatusMandatory;        doc.documents = config?.backgroundCheckDocuments || []; break;
              case 'Background Check Certification':      doc.mandatory = config.backgroundCheckCertificateMandatory;   doc.documents = config?.backgroundCheckCertificationDocuments || []; break;
              case 'Drug Screening':                      doc.mandatory = config.drugScreenMandatory;                   doc.documents = config?.drugScreenDocuments || []; break;
            }
          }
          const allVerified = res?.data?.documentProgress?.allMandatoryVerified;
          this.totalMandatoryDocuments = allVerified
            ? (res?.data?.documentProgress?.totalVerifiedCount ?? 0)
            : (res?.data?.documentProgress?.headerCount ?? 0);
          this.allVerified = allVerified;
        },
        error: (err: any) => console.error('Error fetching document details', err)
      });
  }
}

